import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const contentQueries = [
  'waiverContents',
  'waiverContent',
];

/** Queries that embed or resolve pinned content blocks. */
const contentEmbeddedQueries = [
  ...contentQueries,
  'waiverTemplates',
  'waiverTemplate',
  'waiverPublishedTemplates',
  'waiverForms',
  'waiverForm',
];

const waiverContentMutations: UpdatesConfig['Mutation'] = {
  waiverContentCreate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(contentQueries, cache);
  },
  waiverContentUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(contentEmbeddedQueries, cache);
  },
  waiverContentStatusUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(contentEmbeddedQueries, cache);
  },
};

export default waiverContentMutations;
